module.exports = __webpack_public_path__ + "static/media/bicycles_video_featured.4e747555.jpg";